import type { ReactElement } from 'react'

import { MepSettingsScreen } from './MepSettingsPage'
import type { SettingsSection } from './MepSettingsPage'

const SECTIONS: Array<SettingsSection> = [
  {
    legend: 'Margen',
    numbers: [
      { key: 'marginMin', label: 'Margen antes del paso de cocina (min)', hint: 'Lista tantos minutos antes de que cocina empiece (10).', integer: true },
      { key: 'graceMin', label: 'Gracia (min)', hint: 'Pasada la duración, cuánto antes de «TARDE · sin parar»; y para «el paso ya debería cocinar» (10).', integer: true },
      { key: 'startWindowMin', label: 'Ventana de «Empezar ya» (min)', hint: 'Cuánto antes de su «empezar antes de» (45).', integer: true },
    ],
    lists: [],
  },
  {
    legend: 'Calor',
    numbers: [],
    lists: [
      { key: 'heatThresholdsMin', label: 'Umbrales de calor (min de margen)', hint: 'Frío, templado, caliente y ardiente: 120, 60, 15, 0.', length: 4, signed: true },
      { key: 'exclamationThresholdsMin', label: 'Umbrales de las ! (min de retraso)', hint: '!! desde el primero, !!! desde el segundo: 15, 45.', length: 2 },
    ],
  },
]

/**
 * Administración → Mise en place → Margen y calor (MEP-P C): when a task has
 * to be ready, and how hot the board paints it as that time comes near.
 */
export const MepMarginHeatPage = (): ReactElement => (
  <MepSettingsScreen
    title="Margen y calor"
    intro="Cuándo tiene que estar lista una tarea y cómo de caliente la pinta el tablero: el margen antes del paso de cocina, la gracia antes de «TARDE · sin parar», la ventana de «Empezar ya» y los umbrales del calor y de las !. Entre paréntesis, el valor por defecto."
    sections={SECTIONS}
    saveLabel="Guardar"
    savedText="Guardado · queda en el historial de configuración."
  />
)
